import { Component, OnInit } from '@angular/core';

import { NotyService } from '../../../services/common/noty.service';
import { UserService } from '../../../services/users/user.service';

@Component({
  selector: 'app-user-index',
  templateUrl: './user-index.component.html',
  styleUrls: ['./user-index.component.scss'],
})
export class UserIndexComponent implements OnInit {
  params: any = {};

  loading: boolean = true;

  users: any = [];

  constructor(private notyService: NotyService, private userService: UserService) {}

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    this.userService.index(this.params).then((response_json) => {
      this.loading = false;
      this.users = response_json.users;
    });
  }

  toggleInactive() {
    this.params.show_inactive = !this.params.show_inactive;
    this.loadUsers();
  }
}
